import { render, staticRenderFns } from "./ChartBar.vue?vue&type=template&id=06ab09ed&scoped=true&"
import script from "./ChartBar.vue?vue&type=script&lang=js&"
export * from "./ChartBar.vue?vue&type=script&lang=js&"
import style0 from "./ChartBar.vue?vue&type=style&index=0&id=06ab09ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ab09ed",
  null
  
)

export default component.exports